var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":_vm.columnCardsSpan}},[_c('el-card',{attrs:{"shadow":"always"}},[_c('el-row',[_vm._v(_vm._s(_vm.ColumnCardHeader))]),_c('el-row',{staticClass:"flex-container"},[_c('el-col',{attrs:{"span":6}},[_c('i',{staticClass:"el-icon-user"})]),_c('el-col',{attrs:{"span":12}},[_vm._v(" "+_vm._s(_vm.EmployeesQTY)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }